import { gql } from '@apollo/client';
const GET_MODEL_PROJECTIONS = gql `
  query GetModelProjections($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        projections {
          edges {
            node {
              id
              name
              number
              picture
              points {
                edges {
                  node {
                    id
                    x
                    y
                    note
                    noteX
                    noteY
                    photoNumber
                    isVisible
                    typeCode
                    photo
                    component {
                      id
                      name
                      productCategory {
                        id
                        type
                        typeLabelPL
                        typeLabelEN
                        typeIcon
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_MODEL_PROJECTIONS;
